import CloseIcon from '@mui/icons-material/Close';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {AppBar, Button,IconButton, ScopedCssBaseline, Toolbar} from '@mui/material';
import { Alert, Snackbar } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import jsPDF from 'jspdf';
import PropTypes from 'prop-types';
import React, {useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';

//import  from '../../../src/Assets/LOGOHTH.png';
import logoDataDelegates from '../../../src/Assets/LOGOHTH.png';
import { extractCountryName } from '../../data/Countries';
import { dureeBdcEnum,getFournisseurInfo, modeTravailEnum, regimeTravailEnum } from '../../data/Interfaces';
//import useAuth from '../../hooks/useAuth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../hooks/useNumberFormatting';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import StatutDocument from '../../Pages/Client/DocAdministratifs/StatutDocument';
import { ordreMissionStyles } from '../../Styles/componentStyles';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, LabelSignaturePCOM, referenceOrdreMission, searchLabelInEnumByValue, TestNullValue } from '../../Utils/utils';
import DialogRejet from '../Dialogs/DialogRejet';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import QuillAdvancedTextArea from '../shared/QuillAdvancedTextArea';
import { Transition } from '../shared/ReusableSmallComponents';

const OrdreMission = ({ mission, handleClose, open }) => {

    OrdreMission.propTypes = {
        children: PropTypes.any,
        mission: PropTypes.any,
        open: PropTypes.any,
        handleClose: PropTypes.func,
    };
    const { addEuro4Decimal } = useNumberFormatting();
    const [openNested, setOpenNested] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [message, setMessage] = useState('false');
    const [finalClient,setFinalClient]=useState();
    const descriptionElementRef = React.useRef(null);
    const role = useRole();
    const {device}=useWindowSize();
    const axiosPrivate = useAxiosPrivate();
    const [fournisseur,setFournisseur]=useState({});
    const { i18n } = useTranslation();
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    };
    //const { auth } = useAuth();
    const handleGeneratePdf = () => {
        //const doc = new jsPDF({
        //    format: 'a2',
        //    unit: 'px',
        //});
        const doc = new jsPDF('p', 'pt', [1200/96*72, 1550/96*72]);
        doc.html(document.getElementById('reportTemplateRef'),
            {
                async callback(doc) {
                    await doc.save(mission?.refOrdreMission);
                },
                //margin:[40,48,50,30],
                // Adjust your margins here (top, right, bottom ,left)
                margin:[30,0,70,20],
                autoPaging:'text',
            },
        );
    };

    const handleCloseNested = () => {
        setOpenNested(false);
    };
    const handleClickOpenNested = () => {
        setOpenNested(true);
    };

    // ? we focus on what here
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    useEffect(() => {
        if(mission){
            let fourniss={};
            console.log('mission?.BDCs?.backOfficeId',mission?.BDCsOP[0]?.backOfficeId);
            fourniss.chargeRecrutement=getNomPrenomClearFromPersoData(mission?.BDCsOP[0]?.backOfficeId?.persoData);
            fourniss.tele=mission?.BDCsOP[0]?.backOfficeId?.persoData?.tele;
            fourniss.email=mission?.BDCsOP[0]?.backOfficeId?.persoData?.email;
            setFournisseur(fourniss);
            setFinalClient(mission?.companyDataId ?? mission?.esnId);
        }
    }, [mission]);

    const switchOrdreMission = async (action) => {
        setOpenNested(false);
        console.log(action);
        try {
            const response1 = await axiosPrivate.post('/mission/switchordreMission',
                { missionId: mission?.id, action});
            const responseData1 = await response1.data;
            setMessage(responseData1?.message);
        } catch (error) {
            console.log(error.response?.status);
            setMessage(error.response?.data?.error);
        }
        setOpenSnackBar(true);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullScreen
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                    display: 'flex',
                    flexDirection:'row',
                    justifyContent:'center',
                    padding: '24px',
                },
            }}
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            {mission &&
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',justifyContent:'space-around',background: '#F5F6FA',paddingTop: '90px',paddingBottom: '24px',width:'100%',gap:device=='desktop'?'0px':'16px'}}>

                    <div className='OrdreMissionFile'>
                        <ScopedCssBaseline>
                            <div
                                id='reportTemplateRef'
                                style={ordreMissionStyles.page}
                            >
                                <div
                                    style={ordreMissionStyles.logo54321}
                                >
                                    {/*<img src={png}/> hth*/}
                                    <img src={logoDataDelegates}/>
                                    {/*<Logo />*/}
                                </div>

                                <div style={ordreMissionStyles.FileFrame1Box15467}>
                                    <div style={ordreMissionStyles.OrdreMissionFileTitles2}>
                                        <div style={ordreMissionStyles.FieldsRow1}>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFile}> {i18n.t('Société')}: </p>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>&nbsp;{getFournisseurInfo(mission?.BDCsOP[0]?.backOfficeId?.persoData?.email).societe}</p>
                                        </div>
                                        <div style={ordreMissionStyles.FieldsRow2}>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFile}> {i18n.t('Chargé de recrutement')}: </p>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>&nbsp;{fournisseur.chargeRecrutement}</p>
                                        </div>
                                        <div style={ordreMissionStyles.FieldsRow3}>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFile}> {i18n.t('E-mail')}: </p>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>&nbsp;{fournisseur.email}</p>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F4}>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFile}> {i18n.t('Téléphone')}: </p>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>&nbsp;{fournisseur.tele}</p>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F5}>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFile}> {i18n.t('Siret')}: </p>
                                            <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>&nbsp;{getFournisseurInfo(mission?.BDCsOP[0]?.backOfficeId?.persoData?.email).siret}</p>
                                        </div>

                                    </div>

                                    <div style={ordreMissionStyles.OrdreMissionFileTitles}>
                                        <h4 style={ordreMissionStyles.OrdreMissionFileTitle1}> {i18n.t('Ordre de mission')}</h4>
                                        <div style={ordreMissionStyles.OrdreMissionFileSousTitlesAppWidth}>
                                            <p style={ordreMissionStyles.OrdreMissionFileSousTitle2}>
                                                {i18n.t('Numéro de l\'ordre de mission')}:&nbsp;&nbsp;{referenceOrdreMission(mission?.missionId)}
                                            </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileSousTitle1}>
                                                {i18n.t('Date d\'émission')}:&nbsp;&nbsp;{formatDateJJMMYYYY(mission?.createdAt)}
                                            </p>
                                        </div>

                                        {/*<div style={ordreMissionStyles.OrdreMissionFileSousTitles}>
                                            <p style={ordreMissionStyles.OrdreMissionFileSousTitle11111}>
                                                Numéro de l&apos;ordre de mission: {mission?.refOrdreMission}
                                            </p>
                                        </div>*/}
                                    </div>
                                </div>

                                <div style={ordreMissionStyles.OrdreMissionFileFrame3}>
                                    <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Fournisseur')}</h5>
                                    <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Nom du consultant')}:</p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{getNomPrenomClearFromPersoData(mission?.expert?.persoData)}</p>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Société')}:</p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{mission?.esnExpertOwnerId ? mission?.esnExpertOwnerId?.profileEntreprise?.nom :mission?.expert?.entreprise?.nom }</p>

                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Adresse')}: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{mission?.esnExpertOwnerId ? (mission?.esnExpertOwnerId?.profileEntreprise?.address ? (mission?.esnExpertOwnerId?.profileEntreprise?.address + ', '):' '):(mission?.expert?.entreprise?.address ? (mission?.expert?.entreprise?.address + ', '):' ')}{mission?.esnExpertOwnerId ? extractCountryName(mission?.expert?.entreprise?.localisation) :extractCountryName(mission?.esnExpertOwnerId?.profileEntreprise?.localisation)}</p>
                                        </div>
                                        {mission?.esnExpertOwnerId &&
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Nom du commercial')}: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{getNomPrenomClearFromPersoData(mission?.BDCsOP[0]?.collaboratorEsnExpertId?.persoData)}</p>
                                        </div>
                                        }
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('E-mail')}: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{mission?.esnExpertOwnerId ? mission?.BDCsOP[0]?.collaboratorEsnExpertId?.persoData?.email : mission?.expert?.persoData?.email}</p>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Téléphone')}: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{mission?.esnExpertOwnerId ? mission?.BDCsOP[0]?.collaboratorEsnExpertId?.persoData?.tele  :mission?.expert?.persoData?.tele }</p>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Siret')}: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{mission?.esnExpertOwnerId ? mission?.esnExpertOwnerId?.profileEntreprise?.siret : mission?.expert?.entreprise?.noImmatriculation }</p>
                                        </div>

                                    </div>
                                </div>

                                <div style={ordreMissionStyles.OrdreMissionFileFrame4}>
                                    <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Identification du client')}</h5>
                                    <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame223F1Intitule}> {i18n.t('Société')}:</p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{finalClient?.profileEntreprise?.nom}</p>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame223F1Intitule}> {i18n.t('Adresse')}: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{finalClient?.profileEntreprise?.address +', '+extractCountryName(finalClient?.profileEntreprise?.localisation)+ ', '+finalClient?.profileEntreprise?.codePostal}</p>
                                        </div>
                                        {/* masquer pour #v0 */}
                                        {/*<div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame223F1Intitule}> Responsable opérationnel: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{getNomPrenomClearFromPersoData(mission?.BDCsOP[0]?.responsableOperationnelId?.persoData)} </p>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame223F1Intitule}> Téléphone: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{mission?.BDCsOP[0]?.responsableOperationnelId?.persoData?.tele}</p>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame223F1Intitule}> Email: </p>
                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{mission?.BDCsOP[0]?.responsableOperationnelId?.persoData?.email}</p>
                                        </div>*/}

                                    </div>
                                </div>

                                <div style={ordreMissionStyles.OrdreMissionFileFrame5}>
                                    <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Identification de la mission')}</h5>
                                    <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3Row1}>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Référence de la mission')}:&nbsp;</p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{mission?.missionId}</p>
                                            </div>
                                            <div style={{width:'50%'}}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleMiss}> {i18n.t('Intitulé de la mission')}:&nbsp;</p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleMiss}>{mission?.titre}</p>
                                            </div>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3Row2}>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Date de démarrage')}:&nbsp;</p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}> {formatDateJJMMYYYY(mission?.BDCsOP[0]?.dateDebutBDC)}</p>

                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Date de fin 1er BDC')}:&nbsp;</p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{formatDateJJMMYYYY(mission?.BDCsOP[0]?.dateFinBDC)}</p>

                                            </div>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3Row3}>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Nombre de jours (estimé)')}:&nbsp; </p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>&nbsp;{mission?.BDCsOP[0]?.nbJoursBDC} </p>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Lieu')}:&nbsp; </p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{mission?.localisation}</p>
                                            </div>

                                        </div>

                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3Row4}>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Date de fin (estimée)')}:&nbsp; </p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{formatDateJJMMYYYY(mission?.dateFinMission)}</p>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Fréq. de renouv.BDC')}:&nbsp; </p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{i18n.t(searchLabelInEnumByValue(dureeBdcEnum,mission?.BDCsOP[0]?.frequenceRenouv))}</p>
                                            </div>
                                        </div>

                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3Row5}>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Régime de mission')}:&nbsp; </p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{i18n.t(searchLabelInEnumByValue(regimeTravailEnum,mission?.BDCsOP[0]?.regimeTravail?.type))} </p>
                                            </div>

                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.AppLineH}> {i18n.t('Nb de jours (si temps partiel)')}:&nbsp; </p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{typeof(mission?.BDCsOP[0][0]?.regimeTravail?.nbJrsPartielPerWeek)!='undefined'? ' ': TestNullValue(mission?.BDCsOP[0]?.regimeTravail?.nbJrsPartielPerWeek)}</p>
                                            </div>

                                        </div>

                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3Row6}>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Mode de travail')}:&nbsp; </p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{i18n.t(searchLabelInEnumByValue(modeTravailEnum,mission?.BDCsOP[0]?.modeTravail?.type))}</p>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Fréquence (télétravail)')}:&nbsp; </p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{TestNullValue(mission?.BDCsOP[0]?.modeTravail?.nbJrsRemotePerWeek)!=' ' ? TestNullValue(mission?.BDCsOP[0]?.modeTravail?.nbJrsRemotePerWeek)+' Jours' :' '}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div style={ordreMissionStyles.OrdreMissionFileFrame6}>
                                    <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Vos obligations')}</h5>
                                    <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                        <ul>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Vous devez prendre connaissance et respecter le règlement intérieur et toutes les politiques et procédures du client.')}</li>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Vous devez respecter le secret professionnel vis-à-vis des informations obtenues chez le client.')}</li>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Vous devez prendre connaissance et respecter les dispositions spécifiques de sécurité chez le client.')}</li>

                                        </ul>
                                    </div>
                                </div>

                                <div style={ordreMissionStyles.OrdreMissionFileFrame7}>
                                    <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Durant la mission')}</h5>
                                    <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                        <ul>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Chaque fin de mois, vous devez remplir et valider le compte rendu d\'activité (CRA) mensuelle pour le mois écoulé, afin que le client le valide à son tour, ce qui va permettre par la suite de générer la facture de la prestation.')}</li>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Toute absence prévisible doit être signalée au client le plutôt possible, les absences non prévues (maladies,etc.) doivent être également signalées le plus rapidement possible.')}</li>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Vous devez suivre l\'organisation du temps de travail telle qu\'elle est décrite dans l\'accord avec le client.')}</li>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Pour n\'importe quel problème contactez le chargé de recrutement de High Tech Hires.')}</li>
                                        </ul>
                                    </div>
                                </div>

                                <div style={ordreMissionStyles.OrdreMissionFileFrame7}>
                                    <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Facturation')}</h5>
                                    <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                        <ul>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Délais de paiement défini par le client est : ')} <span><b>{mission?.companyDataId?.donneeFacturation?.delaiPaiement ?? mission?.esnExpertOwnerId?.donneeFacturation?.delaiPaiement} </b></span>{i18n.t('jours, à compter de la fin du mois de la prestation, à condition de la validation du compte rendu d\'activité par le consultant et le client.')}</li>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('La facture est générée par le système une fois le compte rendu d\'activité(CRA) est validé par le consultant et le client.')}</li>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Vous devez prendre connaissance et respecter les dispositions spécifiques de sécurité chez le client.')}</li>
                                        </ul>
                                    </div>
                                </div>

                                <div style={ordreMissionStyles.OrdreMissionFileFrame8}>
                                    <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Conditions particulières et préavis')}</h5>
                                    <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                        <ul>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('La validation de l\'ordre de mission sur la plateforme est considérée une signature électronique du document, qui va permettre de générer le 1er bon de commande. Tout nouveau renouvellement de ce dernier se fera automatiquement par le système après accord entre le client et le consultant.')}</li>
                                            <li style={ordreMissionStyles.ListStyle}>{i18n.t('Si le consultant ou le client veut interrompre une mission en cours, il faut envisager un préavis de 30 jours.')}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div style={ordreMissionStyles.OrdreMissionFileFrame9}>
                                    <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Prix de la prestation')}</h5>
                                    <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3Row1}>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Taux journalier (HT)')}:&nbsp;</p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>
                                                    {addEuro4Decimal(mission?.BDCsOP[0]?.tj)}
                                                </p>
                                            </div>
                                        </div>
                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3Row2}>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Frais de déplacement')}:&nbsp;</p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{i18n.t('Soumis à l\'accord entre le client et l\'expert')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={ordreMissionStyles.OrdreMissionFileFrame10}>
                                    <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t(LabelSignaturePCOM(mission?.ordreDeMission?.statut))+':'}</p>
                                    <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{formatDateJJMMYYYY(mission?.ordreDeMission?.dateSignature)}</p>
                                </div>
                            </div>
                        </ScopedCssBaseline>
                    </div>
                    {device!='desktop' &&
                        <Button
                            className='TelechargerMissionOM'
                            //onClick={printOrdreMission}
                            onClick={handleGeneratePdf}
                            variant="text"
                            style={{...buttonStyles(),...{color:'#272D3C',background:device=='desktop'?'none':'#E7EAF9',order:1,width:'100%'}}}
                            startIcon={<FileDownloadOutlinedIcon style={{color:'#272D3C'}} />}
                            //onClick={handleExportWithComponent}
                        >
                            {i18n.t('Télécharger')}
                        </Button>
                    }
                    <div className='Frame123OM'>
                        {/*<div className='frame00FicheCollab'>
                            <div className='frame01FicheCollab'>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>*/}
                        {device!='desktop' &&
                            <div style={{display:'flex',flexDirection:'column',gap:'16px',width:'100%'}}>
                                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                                    <h5 className='TitleFrame1OM'>
                                        {i18n.t('Ordre de mission')}
                                    </h5>
                                    <IconButton
                                        //className='TelechargerMissionOM'
                                        //onClick={printOrdreMission}
                                        onClick={handleGeneratePdf}
                                        variant="outlined"
                                        style={{...buttonStyles(),...{color:'#214DCE',border: '1px solid #214DCE',order:2,margin:'0'}}}
                                        //startIcon={<FileDownloadOutlinedIcon style={{color:'#214DCE',margin:'0px'}} />}
                                        //onClick={handleExportWithComponent}
                                    >
                                        <FileDownloadOutlinedIcon style={{color:'#214DCE',margin:'0px'}} />
                                    </IconButton>
                                </div>
                                <div style={{borderBottom:'solid 2px #C3C9F1',margin:'0px'}}></div>
                            </div>
                        }
                        <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
                            <StatutDocument
                                statut={mission?.ordreDeMission?.statut}
                                motifRejet={mission?.ordreDeMission?.motifRejet}
                            />
                            {mission?.ordreDeMission?.dateSignature &&
                                <div
                                    style={{display:'flex',flexDirection:'row',
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        fontSize: '12px',
                                        lineHeight: '16px',
                                        alignItems: 'flex-start',
                                        textAlign: 'flex-start',
                                        letterSpacing: '0.004em',
                                        color: '#475063',
                                    }}
                                >
                                    <p style={{margin:'0'}}>{mission?.ordreDeMission?.statut=='rejete' ?i18n.t('Rejetée le: ') :i18n.t('Signée le: ')} {formatDateJJMMYYYY(mission?.ordreDeMission?.dateSignature)}</p>
                                </div>
                            }
                        </div>
                        {device=='desktop' &&
                        <h5 className='TitleFrame1OM'>
                            {i18n.t('Ordre de mission')}
                        </h5>
                        }
                        <div className='Frame2OM'>
                            <h6 className='TitleFrame2OM'>
                                {mission?.titre}
                            </h6>
                            <div className='Frame23OM'>
                                <div className='Frame23COM'>
                                    <img
                                        src={finalClient?.profileEntreprise?.logo}
                                        className='ImageOM'
                                    />
                                    <div className='TextImageOM'>
                                        <p className='Title1Frame3OM'>
                                            {finalClient?.profileEntreprise?.nom}
                                        </p>
                                        <p className='Title2Frame3OM'>
                                            {i18n.t('Ordre de mission N°')}: {referenceOrdreMission(mission?.missionId)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='Frame9OM'>
                            {mission?.aoId  && (
                                <div className='Frame4OMBox1OM'>
                                    <p className='Frame4Box1TitleOM'>{i18n.t('Contexte de la mission')}</p>
                                    <QuillAdvancedTextArea
                                        value={mission?.aoId?.description || i18n.t('pas de description')}
                                        readOnly={true}
                                        className='Frame4Box1ContentOM'
                                        theme='bubble'
                                    />
                                </div>
                            )}
                            {device=='desktop' &&
                            <div className='Frame4OMBox2OM'>
                                <Button
                                    style={{...buttonStyles(),...{color:'#272D3C'}}}
                                    startIcon={<FileDownloadOutlinedIcon style={{color:'#272D3C'}} />}
                                    variant='text'
                                    onClick={handleGeneratePdf}
                                >{i18n.t('Télécharger')}</Button>
                            </div>
                            }
                        </div>
                        {(role=='client' || role=='expert' || role=='esn') && (mission?.statut!='signe') &&
                            <>
                                <div className='LineVect2OM'>
                                </div>
                                <div className='Frame6OM'>
                                    <div className='Frame6OMBtn'>
                                        {(mission?.statut!='rejete') &&
                                        <div className='RejeterOM'>
                                            <Button
                                                variant='outlined'
                                                style={{...buttonStyles(),
                                                    ...{
                                                        borderColor:'#EC5B56',color:'#EC5B56'}
                                                }}
                                                onClick={()=>handleClickOpenNested()}
                                            >
                                                {i18n.t('Rejeter')}
                                            </Button>
                                        </div>
                                        }
                                        <div className='AccepterOM'>
                                            <Button
                                                variant='contained'
                                                style={{...buttonStylesGreen(false)}}
                                                onClick={async () => {
                                                    await switchOrdreMission('accept');
                                                    handleClose();
                                                }}
                                            >
                                                {i18n.t('Valider')}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            }
            <DialogRejet
                handleCloseDialogRejet={()=>{
                    handleCloseNested();
                    handleClose();
                }}
                openDialogRejet={openNested}
                missionId={mission?.id}
            />
            <Snackbar
                open={openSnackBar}
                autoHideDuration={6000}
                onClose={handleCloseSnackBar}
            >
                <Alert
                    onClose={handleCloseSnackBar}
                    severity="info"
                    sx={{ width: '100%' }}
                >
                    {i18n.t('message')}: { message}
                </Alert>
            </Snackbar>
        </Dialog>
    );
};

export default OrdreMission;